import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';

const SummaryLineChart = ({
	metricField,
	metricData,
	channels,
	metricInitialVal,
}) => {
	const colors = [
		'#3366CB',
		'#DC3912',
		'#F69906',
		'#7c5cdb',
		'#ce5cdb',
		'#db5c97',
		'#9fc934',
		'#60d17e',
	];

	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState('');
	const [metricFilter, setMetricFilter] = useState(metricInitialVal);
	const [labels, setLabels] = useState([]);

	useEffect(() => {
		if (metricData) {
			setRowsData(metricData.lineData);
		}
	}, [metricData]);

	useEffect(() => {
		if (metricField && metricField[0] && rowsData) {
			const filterMetric = metricField[0].value;

			if (filterMetric) {
				let labels;
				const data = [];
				setMetricFilter(filterMetric);
				const allData = rowsData[filterMetric].map((e, i) => {
					if (e.labels) {
						labels = e.labels;
					}
					if (!e.data) return;
					data.push(e);
				});
				const mapData = data.map((e, i) => {
					return {
						label: e.label,
						fill: false,
						data: e.data,
						borderColor: colors[i], // The main line color
						pointRadius: 0,
						pointHitRadius: 10,
						borderWidth: 2,
						lineTension: 0.3,
					};
				});
				if (channels[0] && channels[0].value) {
					channels.forEach((e) => {
						if (e.value) {
							const d = currentData.filter((i) => i.label === e.value);

							setCurrentData(d);
							setLabels(d[0] && d[0].label);
						} else {
							setCurrentData(currentData);
						}
					});
				} else {
					setLabels(labels);
					setCurrentData(mapData);
				}
			} else {
				let labels;
				setMetricFilter(metricInitialVal);
				const data = [];
				const allData =
					rowsData[metricInitialVal] &&
					rowsData[metricInitialVal].map((e, i) => {
						if (e.labels) {
							labels = e.labels;
						}
						if (!e.data) return;
						data.push(e);
					});
				const mapData = data.map((e, i) => {
					return {
						label: e.label,
						fill: false,
						data: e.data,
						borderColor: colors[i], // The main line color
						pointRadius: 0,
						pointHitRadius: 10,
						borderWidth: 2,
						lineTension: 0.3,
					};
				});

				if (channels[0] && channels[0].value) {
					channels.forEach((e) => {
						if (e.value) {
							const d = mapData.filter((i) => i.label === e.value);
							setCurrentData(d);
						} else {
							setCurrentData(mapData);
						}
					});
				} else {
					setLabels(labels);
					setCurrentData(mapData);
				}
			}
		}
	}, [rowsData, metricField, channels]);

	// console.log('currentData', currentData);
	// console.log('metricData', metricData);
	// console.log('labels', labels);

	// console.log('rowsData', rowsData);
	const data = {
		labels: labels,
		datasets: currentData,
	};

	var options = {
		// animation: false,
		scales: {
			// yAxes: [
			// 	{
			// 		scaleLabel: {
			// 			display: true,
			// 			labelString: 'Moola',
			// 			fontSize: 20,
			// 		},
			// 	},
			// ],
			x: {
				ticks: {
					maxTicksLimit: 10,
				},
			},
			y: {
				suggestedMin: -1,
			},
		},

		plugins: {
			title: {
				display: true,
				text: metricFilter,
				font: {
					size: '20px',
				},
			},
			legend: { display: true },
		},
		maintainAspectRatio: false,
	};

	return (
		<div>
			<Line data={data} options={options} width={300} height={420} />
		</div>
	);
};

export default SummaryLineChart;

// const lineChart = [
// 	{ labels: ['19 Jun', '22June', '25June', '28June', '1Jul', '4Jul', '7Jul'] }, // all by dates
// 	{
// 		label: 'Promoters',
// 		data: [50, 25, 50, 40, 10, 13, 16],
// 	},
// 	{
// 		label: 'POSM',
// 		data: [10, 30, 15, 40, 20, 27, 5],
// 	},
// 	{
// 		label: 'SocialMedia',
// 		data: [28, 48, 40, 19, 86, 27, 80],
// 	},
// 	{
// 		label: 'Retailers',
// 		data: [10, 48, 40, 19, 20, 27, 90],
// 	},
// ];

// const pieChart = [
// 	['Promoters', 11],
// 	['POSM', 2],
// 	['SocialMedia', 3],
// 	['Retailers', 5],
// ];

// const horizonTalBarChart = [
// 	['Promoters', 11],
// 	['POSM', 2],
// 	['SocialMedia', 3],
// 	['Retailers', 5],
// ];

// // if can set like this would be great, but other format also okay as long as can get the metrics values by each channel
// const tableChart = {
// 	socialMedia: { visitors: 20, redeemed: 100, active: 10, sales: 4000 },
// 	posm: { visitors: 202, redeemed: 200, active: 15, sales: 5000 },
// 	online: { visitors: 205, redeemed: 300, active: 36, sales: 6000 },
// 	offline: { visitors: 201, redeemed: 400, active: 33, sales: 7000 },
// };

// const tableChart2 = {
// 	{ name: 'SocialMedia',  visitors: 20, redeemed: 100, active: 10, sales: 4000 },
// 	{name: 'Promoters', visitors: 202, redeemed: 200, active: 15, sales: 5000 },
// 	{name: 'POSM', visitors: 205, redeemed: 300, active: 36, sales: 6000 },
//  {name: 'Retailers', visitors: 201, redeemed: 400, active: 33, sales: 7000 },
// };
